<template>
  <div class="accordion">
    <div class="accordion__header">
      <div class="accordion__title">{{ title }}</div>
      <div class="accordion__control">
        <UtilityIconButton
          v-if="isOpen"
          size="md"
          background-color="rgb(255,255,255,0)"
          content="Collapse"
          v-tippy="{ theme: 'statzon', placement: 'left', arrow: true, animation: 'scale' }"
          @click.native="toggle()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 9h24v6h-24z"/></svg>
        </UtilityIconButton>

        <UtilityIconButton
          v-else
          size="md"
          background-color="rgb(255,255,255,0)"
          content="Expand"
          v-tippy="{ theme: 'statzon', placement: 'left', arrow: true, animation: 'scale' }"
          @click.native="toggle()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/></svg>
        </UtilityIconButton>
      </div>
    </div>

    <UtilityScroll
      height="479px"
      topPosition="35px"
    >
      <transition name="transition--accordion">
        <div
          v-if="isOpen"
          :class="' accordion__content' + (noPadding ? ' accordion__content--no-padding' : '')"
        >
          <slot />
        </div>
      </transition>
    </UtilityScroll>
  </div>
</template>

<script>
import UtilityScroll from '@/components/utility/Scroll.vue'
import UtilityIconButton from '@/components/utility/IconButton.vue'

export default {
  components: {
    UtilityScroll,
    UtilityIconButton
  },
  props: {
    title: {
      type: String
    },
    closeInit: {
      type: Boolean
    },
    noPadding: {
      type: Boolean
    }
  },
  data () {
    return {
      isOpen: this.closeInit ? false : true
    }
  },
  methods: {
    toggle () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.accordion {
  @include font('content--md', $white, 0.85);
  display: flex;
  flex-direction: column;
  background-color: $bg-4;
  border-top: 1px solid $black;

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white, 0.85);
  }

  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    user-select: none;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;
    background-color: $bg-2;
  }

  &__title {
    text-transform: uppercase;
  }

  &__content {
    padding: 0 16px;
    border-top: 1px solid rgba($white, 0.1);

    /deep/ p {
      line-height: 1.75rem !important;
    }

    &--no-padding {
      padding: 0 !important;
    }
  }
}

.transition--accordion-enter-active, .transition--accordion-leave-active {
  opacity: 1;
  transform: scale(1);
  transition: opacity 0.25s cubic-bezier(0.0, 0.0, 0.3, 1.0), transform 0.25s cubic-bezier(0.0, 0.0, 0.3, 1.0);
}
.transition--accordion-enter, .transition--accordion-leave-to {
  opacity: 0;
  transform: scaleY(0);
}

</style>
